import {faS} from "@fortawesome/free-solid-svg-icons";

export default faS;
